export default {
  main: {
    title: 'Verificación de Versión',
    language: 'Español',
    intro:
      'La verificación de versión se realiza mediante la coincidencia de los valores hash MD5 o SHA256 entre las versiones. Asegúrese de descargar la billetera TokenPocket a través de canales oficiales para evitar ser engañado. Para obtener instrucciones sobre cómo obtener los valores hash MD5 o SHA256 de una versión, por favor ',
    tutorial: 'consulte el tutorial >',
    system: 'Sistema Operativo',
    android: 'Android',
    ios: 'iOS',
    version: 'Versión',
    allVersion: 'Todas',
    appChannel: 'Canal de la Aplicación',
    developer: 'desarrollador',
    allChannel: 'Todos',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Registro de Versión',
    check: 'Detalles',
    versionLog: 'Registro de Versión',
    confirm: 'Confirmar',
    aboutIOS: 'Acerca de la Versión de iOS',
    IOSDesc:
      'Para las versiones de iOS, solo ofrecemos nuestra aplicación en la App Store. Solo las aplicaciones descargadas a través de la App Store se pueden instalar correctamente. Por lo tanto, al usar dispositivos Apple, asegúrese de autenticar la App Store como el único canal de descarga.',
    IOSDesc_2:
      'El desarrollador de la versión descargada de la App Store antes del 8 de octubre de 2022 es TOKENPOCKET FOUNDATION LTD, que es una versión temprana desarrollada por TokenPocket. Es una billetera legítima que se puede utilizar normalmente, pero el servicio de actualización se suspenderá temporalmente.',
    aboutAndroid: 'Acerca de la versión de Android',
    androidDesc: 'Las opciones de descarga de TokenPocket para Android actualmente incluyen el sitio web oficial, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store y Vivo App Store. En algunas tiendas de aplicaciones, no se puede obtener el archivo de instalación APK durante el proceso de descarga, por lo que no se puede realizar la verificación MD5 o SHA256. Por lo tanto, al descargar, asegúrese de verificar claramente la información del desarrollador consultando lo siguiente!',
    IOSAppName: 'Nombre de la Aplicación:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Ícono de la Aplicación:',
    AppDeveloper: 'Desarrollador:',
    downloadLink: 'URL de Descarga:',
    copied: '¡Copiado!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Síganos',
    desc1: 'TokenPocket Staffs no te enviará mensajes privados!',
    desc2:
      '¡Precaución! Está ingresando a la comunidad TokenPocket, ¡podría haber alguien haciéndose pasar por nosotros para enviarle mensajes privados! ¡Tenga en cuenta que cualquier persona que envíe mensajes privados podría ser un estafador! ¡Nunca te contactaremos primero!',
    desc3: 'Entendido, entra'
  },
  COMMON: {
    LAYOUT: {
      features: 'Características',
      products: 'Productos',
      buyCryptoFooter: 'Покупка',
      mobileWallet: 'Billetera móvil',
      mobileWalletDesc: 'Billetera móvil de Crypto y DeFi en blockchain.',
      hardwareWallet: 'Billetera de hardware',
      hardwareWalletDesc: 'Obtén tu KeyPal, para proteger tus activos.',
      extensionWallet: 'Extensión de billetera',
      extensionWalletDesc: 'Una mejor billetera en tu computadora.',
      desktop: 'Desktop Wallet',
      fiveDegrees: '5Degrees',
      versionVerification: 'Verificación de versión',
      versionVerificationDesc: 'Verifica tu billetera.',
      approvalDetector: 'Detector de aprobaciones',
      approvalDetectorDesc: 'Ve y desaprueba tus tokens aprobados.',
      tokenSecurity: 'Seguridad de tokens',
      tokenSecurityDesc: 'Verifica si el token es seguro por su dirección de contrato.',
      keyGenerator: 'Generador de claves',
      keyGeneratorDesc: 'Genera claves públicas y privadas aleatoriamente para varias redes.',
      tokenProfile: 'Perfil de token',
      tokenProfileDesc: 'Aprende toda la información sobre el token.',
      tokenClaim: 'Reclamación de tokens',
      tokenClaimDesc: 'Reclama tu airdrop.',
      easyInscription: 'Inscripción fácil',
      easyInscriptionDesc: 'Una herramienta de inscripción segura.',
      nostrAssetsBatchSender: 'NostrAssets BatchSender',
      nostrAssetsBatchSenderDesc: 'Una herramienta de envío masivo para NostrAssets.',
      BATCH_SENDER: 'BatchSender',
      BATCH_SENDER_DESC: 'Envía tokens a múltiples destinatarios a la vez.',
  
      trade: 'Comercio',
      swap: 'Intercambio',
      swapDesc: 'Opera con los mejores precios.',
      bridge: 'Puente',
      bridgeDesc: 'Cruza activos sin problemas de una cadena a otra.',
      buyCrypto: 'Comprar',
      buyCryptoDesc: 'Compra criptomonedas con tus tarjetas de crédito.',
      market: 'Mercado',
      marketDesc: 'Información en tiempo real para descubrir tokens populares.',
  
      information: 'Información',
      blockchainGuide: 'Guía de cadena de bloques',
      tronWallet: 'Guía de TRON',
      iostWallet: 'Guía de IOST',
      tpMan: 'TP Man',
  
      developers: 'Desarrolladores',
      github: 'Github (TP-Lab)',
      devCenter: 'Центр разработки',
      developersDesc: 'Документация для разработчиков TokenPocket.',
      subToken: 'Enviar token',
      subTokenDesc: 'Envía tu token.',
      subDApp: 'Enviar DApp',
      subDAppDesc: 'Envía tu DApp, y se mostrará después de la auditoría.',
      subNFT: 'Enviar NFT',
      subNFTDesc: 'Envía tu NFT y arte.',
      subChain: 'Enviar cadena',
      subChainDesc: 'Envía tu blockchain.',
      bugBounty: 'Bug Bounty',
  
      tools: 'Herramientas',
  
      build: 'Construir',
  
      learn: 'Aprender',
  
      explorer: 'Explorador',
  
      company: 'Compañía',
      about: 'Acerca de',
      careers: 'Empleos',
      pressKit: 'Kit de marca',
      swagShop: 'Tienda de artículos de regalo',
  
      support: 'Soporte',
      helpCenter: 'Centro de ayuda',
      helpCenterDesc: 'Tus recursos para obtener respuestas y asistencia.',
      contactUs: 'Contáctenos',
      contactUsDesc: 'Comparte tus sugerencias y haz cualquier pregunta.',
      forum: 'Foro',
      forumDesc: 'Disfruta de tus conversaciones con los miembros de la comunidad.',
  
      legal: 'Legal',
      privacyPolicy: 'Política de Privacidad',
      terms: 'Términos de Uso',
  
      toHome: 'Página Principal',
      defiWallet: 'Billetera DeFi',
      ETHWallet: 'Ethereum na Wallet',
      ethWallet: 'Billetera ETH',

      dappStore: 'Tienda de DApp'
    }
  }
};
